export default __webpack_public_path__ + "static/media/default_image_landing_featured.7a75d093.png";